import React from 'react'

import { get } from 'lodash'

import Mockup from 'components/Mockup'

export default ({ src, phoneMockup, ...otherProps }) => {
  const actualSrc = get(src, 'fields.file.url')

  if (!actualSrc) {
    return null
  }

  if (phoneMockup) {
    return <Mockup src={actualSrc} {...otherProps} />
  } else if (actualSrc.includes('.svg')) {
    return (
      <object style={{ width: '100%' }} data={actualSrc} type="image/svg+xml" {...otherProps} />
    )
  }
  return <img src={actualSrc} {...otherProps} />
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Utils/CmsImg/CmsImg.jsx